import React, { FunctionComponent } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

import LottieView from 'lottie-react-native'
import styled from 'styled-components/native'

import { isChromaticWeb, tID } from '../../utils/utils'

const Container = styled.View<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
  maxWidth: '100%',
}))

// The aspect ratio from the original animation (932 x 780)
const ASPECT_RATIO = 780 / 932

export const RegistrationEmailCaptureAnimation: FunctionComponent<RegistrationEmailCaptureAnimationProps> = ({
  width = 500,
  style,
}) => {
  const calculatedHeight = Math.floor(width * ASPECT_RATIO)

  return (
    <Container width={width} height={calculatedHeight} style={style} testID={tID('RegistrationEmailCaptureAnimation')}>
      <LottieView
        source={require('../../assets/lottie/registrationEmailCaptureAnimatedLottie.json')}
        style={{
          width: '100%',
          height: calculatedHeight,
          maxWidth: width,
          alignSelf: 'center',
        }}
        autoPlay={!isChromaticWeb()} // This will prevent animations during chromatic visual testing
        loop
        resizeMode='contain'
      />
    </Container>
  )
}

type RegistrationEmailCaptureAnimationProps = {
  width?: number
  style?: StyleProp<ViewStyle>
}
